import SingUpComponent from '../components/sing-up/sign-up.jsx'

const singUp = () => <SingUpComponent />

export default singUp;